var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-calendar',{style:({ height: '100vh' }),attrs:{"title":"主页","poppable":false,"show-confirm":false}})}
var staticRenderFns = []

export { render, staticRenderFns }